/**
 * FirstPromoter affiliate tracking helpers.
 * fpr.js is loaded globally in index.html — these helpers wrap the global fpr() calls.
 */

declare global {
  interface Window {
    fpr?: (...args: unknown[]) => void;
  }
}

/**
 * Send a referral tracking event to FirstPromoter after user sign-up.
 * Links the new user's email to the affiliate who referred them.
 */
export function trackReferralSignup(email: string): void {
  if (typeof window === "undefined" || !window.fpr) return;
  window.fpr("referral", { email });
}

/**
 * Read the FirstPromoter tracking ID (tid).
 * Stripe needs this as `fp_tid` in checkout session metadata.
 */
export function getFirstPromoterTid(): string | null {
  if (typeof window === "undefined") return null;
  const fprom = (window as any).FPROM;
  if (fprom?.data?.tid) return fprom.data.tid;
  const match = document.cookie.match(/(?:^|;\s*)_fprom_tid=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}
